import React from "react";
import BackGround from "components/common/BackGround";
import useMediaQuery from "hooks/useMediaQuery";
import Gnb from "components/common/Gnb";
import Footer from "components/common/Footer";
import Lending from "components/main/Lending";
import DownloadApp from "components/main/DownloadApp";
import HeadLine from "components/main/HeadLine";
import PnS from "components/main/PnS";
import Approach from "components/main/Approach";
import ScrollToTopButton from "components/common/ScrollToTopButton";
import PnSMobile from "components/main/PnSMobile";

export default function Main() {
    const isMobile = useMediaQuery("(max-width: 1023px)");

    return (
        <BackGround>
            <Gnb />
            <Lending />
            {isMobile ? (
                <PnSMobile />
            ) : (
                <>
                    <PnS />
                    <Approach />
                </>
            )}
            <HeadLine />
            <DownloadApp />
            <Footer />
            <ScrollToTopButton />
        </BackGround>
    );
}
